import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer style={{
      background: 'var(--bg-secondary)',
      borderTop: '1px solid var(--border-light)',
      padding: '80px 0 40px 0',
      marginTop: '120px'
    }}>
      <div className="container">
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '48px',
          marginBottom: '48px'
        }}>
          {/* About Section */}
          <div>
            <h3 style={{
              fontSize: '18px',
              fontFamily: "'Cormorant Garamond', serif",
              marginBottom: '16px',
              fontWeight: 600
            }}>
              Get Lucid
            </h3>
            <p style={{
              color: 'var(--text-secondary)',
              fontSize: '14px',
              lineHeight: '1.7',
              marginBottom: '16px'
            }}>
              Unlock Your Mind, Transform Your Life
            </p>
            <p style={{
              color: 'var(--text-secondary)',
              fontSize: '14px',
              lineHeight: '1.7'
            }}>
              Professional hypnotherapy and transformational healing with Tara Phillips.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 style={{
              fontSize: '16px',
              fontFamily: "'Cormorant Garamond', serif",
              marginBottom: '16px',
              fontWeight: 600
            }}>
              Quick Links
            </h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <Link to="/services" style={{ color: 'var(--text-secondary)', textDecoration: 'none', fontSize: '14px' }}>Services</Link>
              <Link to="/about" style={{ color: 'var(--text-secondary)', textDecoration: 'none', fontSize: '14px' }}>About</Link>
              <Link to="/events" style={{ color: 'var(--text-secondary)', textDecoration: 'none', fontSize: '14px' }}>Events</Link>
              <Link to="/blog" style={{ color: 'var(--text-secondary)', textDecoration: 'none', fontSize: '14px' }}>Blog</Link>
            </div>
          </div>

          {/* Resources */}
          <div>
            <h4 style={{
              fontSize: '16px',
              fontFamily: "'Cormorant Garamond', serif",
              marginBottom: '16px',
              fontWeight: 600
            }}>
              Resources
            </h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <Link to="/faqs" style={{ color: 'var(--text-secondary)', textDecoration: 'none', fontSize: '14px' }}>FAQs</Link>
              <Link to="/testimonials" style={{ color: 'var(--text-secondary)', textDecoration: 'none', fontSize: '14px' }}>Testimonials</Link>
              <Link to="/contact" style={{ color: 'var(--text-secondary)', textDecoration: 'none', fontSize: '14px' }}>Contact</Link>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h4 style={{
              fontSize: '16px',
              fontFamily: "'Cormorant Garamond', serif",
              marginBottom: '16px',
              fontWeight: 600
            }}>
              Connect
            </h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <a href="mailto:getlucidwithtaraphillips@gmail.com" style={{ color: 'var(--text-secondary)', textDecoration: 'none', fontSize: '14px' }}>
                getlucidwithtaraphillips@gmail.com
              </a>
              <a href="tel:+919008455435" style={{ color: 'var(--text-secondary)', textDecoration: 'none', fontSize: '14px' }}>
                +91 9008 455 435
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div style={{
          paddingTop: '32px',
          borderTop: '1px solid var(--border-light)',
          textAlign: 'center',
          color: 'var(--text-secondary)',
          fontSize: '12px'
        }}>
          <p>© {new Date().getFullYear()} Get Lucid. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
